//
// Standard Percentage (0 - 100%)

import type { FormConfig, I18NFunction } from "../form-config-types";

//
// Role -- Using the translatin internally here rather than on client side tsx route.
//
export const roleEnum = ["admin", "user", "chair", "regeneron_msl", "regeneron_non_msl"] as const;
export const mapToRoleEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof roleEnum)[number], string> = {
    admin: l("Admin", "Administrateur"),
    user: l("User", "Utilisateur"),
    chair: l("Chair", "Président(e)"),
    regeneron_msl: l("Regeneron MSL", "MSL Regeneron"),
    regeneron_non_msl: l("Regeneron Non-MSL", "Non-MSL Regeneron"),
  };
  return map[key as (typeof roleEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Region  -- Using the translatin internally here rather than on client side tsx route.
//
export const regionEnum = ["ontario", "quebec", "atlantic", "british_columbia", "alberta", "testing"] as const;
export const mapToRegionEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof regionEnum)[number], string> = {
    ontario: l("Ontario", "Ontario"),
    quebec: l("Quebec", "Québec"),
    atlantic: l("Atlantic", "Atlantique"),
    british_columbia: l("British Columbia", "Colombie-Britannique"),
    alberta: l("Alberta", "Alberta"),
    testing: l("Test Region", "Test Region"),
  };
  return map[key as (typeof regionEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// job title  -- Using the translatin internally here rather than on client side tsx route.
//
export const jobTitleEnum = [
  "medical_oncologist",
  "radiation_oncologist",
  "surgical_oncologist",
  "pcp",
  "ent",
  "dermatologist",
  "dermatologist_and_mohs_surgeon",
  // regeneron
  "associate_director_medical_affairs",
  "sr_marketing_manager",
  "sr_manager_field_medical_affairs",
  "internal",
] as const;
export const mapToJobTitleEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof jobTitleEnum)[number], string> = {
    medical_oncologist: l("Medical Oncologist", "Oncologue médical"),
    radiation_oncologist: l("Radiation Oncologist", "Radio-oncologue"),
    surgical_oncologist: l("Surgical Oncologist", "Oncologue chirurgical"),
    pcp: l("Primary Care Physician", "Médecin de famille"),
    ent: l("ENT Surgeon", "Chirurgien ORL"),
    dermatologist: l("Dermatologist", "Dermatologue"),
    dermatologist_and_mohs_surgeon: l("Dermatologist and Mohs Surgeon", "Dermatologue et chirurgien Mohs"),
    // regeneron
    associate_director_medical_affairs: l(
      "Associate Director Medical Affairs",
      "Directeur associé des affaires médicales",
    ),
    sr_marketing_manager: l("Senior Marketing Manager", "Directeur marketing senior"),
    sr_manager_field_medical_affairs: l(
      "Senior Manager Field Medical Affairs",
      "Directeur senior des affaires médicales sur le terrain",
    ),
    // internal
    internal: l("Internal", "Interne"),
  };
  return map[key as (typeof jobTitleEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
export const standardPercentageEnum = ["0", "1_to_20", "21_to_40", "41_to_60", "61_to_80", "81_to_100"] as const;
export const mapToStandardPercentageEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof standardPercentageEnum)[number], string> = {
    "0": l("0%", "0 %"),
    "1_to_20": l("1-20%", "1-20 %"),
    "21_to_40": l("21-40%", "21-40 %"),
    "41_to_60": l("41-60%", "41-60 %"),
    "61_to_80": l("61-80%", "61-80 %"),
    "81_to_100": l("81-100%", "81-100 %"),
  };
  return map[key as (typeof standardPercentageEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// standard percentage with not applicable
//
// export const standardPercentageWithNotApplicableEnum = [
//   "0",
//   "1_to_20",
//   "21_to_40",
//   "41_to_60",
//   "61_to_80",
//   "81_to_100",
//   "Not Applicable",
// ] as const;
// export const mapToStandardPercentageWithNotApplicableEnumLabels = (key: string, l: I18NFunction) => {
//   const map: Record<(typeof standardPercentageWithNotApplicableEnum)[number], string> = {
//     "0": l("0%", "0 %"),
//     "1_to_20": l("1-20%", "1-20 %"),
//     "21_to_40": l("21-40%", "21-40 %"),
//     "41_to_60": l("41-60%", "41-60 %"),
//     "61_to_80": l("61-80%", "61-80 %"),
//     "81_to_100": l("81-100%", "81-100 %"),
//     "Not Applicable": l("Not Applicable", "Non applicable"),
//   };
//   return map[key as (typeof standardPercentageWithNotApplicableEnum)[number]] ?? l("Unknown", "Inconnu");
// };

//
// Num Patients (0 - 50+)
//
export const numPatientsEnum = ["0", "1_to_10", "11_to_20", "21_to_30", "31_to_40", "41_to_50", "50_plus"] as const;
export const mapToNumPatientsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof numPatientsEnum)[number], string> = {
    "0": l("0", "0"),
    "1_to_10": l("1-10", "1-10"),
    "11_to_20": l("11-20", "11-20"),
    "21_to_30": l("21-30", "21-30"),
    "31_to_40": l("31-40", "31-40"),
    "41_to_50": l("41-50", "41-50"),
    "50_plus": l("50+", "50+"),
  };
  return map[key as (typeof numPatientsEnum)[number]] ?? "Unknown";
};

//
// Yes or No  -- Using the translatin internally here rather than on client side tsx route.
//
export const yesNoEnum = ["Yes", "No"] as const;
export const mapToYesNoEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof yesNoEnum)[number], string> = {
    Yes: l("Yes", "Oui"),
    No: l("No", "Non"),
  };
  return map[key as (typeof yesNoEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Types of specialists incl. Others  -- Using the translatin internally here rather than on client side tsx route.
//
// Dermatologists [checkbox]
// Surgical oncologists [checkbox]
// Radiation oncologists [checkbox]
// Pathologists [checkbox]
// GP oncologists [checkbox]
// Medical oncologists [checkbox]
// Community medical oncologists [checkbox]
// Others (please specify) [open box]

export const typesOfSpecialistsEnum = [
  "dermatologists",
  "surgical_oncologists",
  "rad_oncologists",
  "pathologists",
  "gp_oncologists",
  "medical_oncologists",
  "community_medical_oncologists",
  "others",
] as const;
export const mapToTypesOfSpecialistsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof typesOfSpecialistsEnum)[number], string> = {
    dermatologists: l("Dermatologists", "Dermatologues"),
    surgical_oncologists: l("Surgical oncologists", "Oncologues chirurgicaux"),
    rad_oncologists: l("Radiation oncologists", "Radio-oncologues"),
    pathologists: l("Pathologists", "Pathologistes"),
    gp_oncologists: l("GP oncologists", "Oncologues généralistes"),
    medical_oncologists: l("Medical oncologists", "Oncologues médicaux"),
    community_medical_oncologists: l("Community medical oncologists", "Oncologues médicaux communautaires"),
    others: l("Others", "Autres"),
  };
  return map[key as (typeof typesOfSpecialistsEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Frequency of meetings  -- Using the translatin internally here rather than on client side tsx route.
//
export const typesOfMeetingFrequencyEnum = ["weekly", "monthly", "other"] as const;
export const mapToTypesOfMeetingFrequencyEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof typesOfMeetingFrequencyEnum)[number], string> = {
    weekly: l("Weekly", "Hebdomadaire"),
    monthly: l("Monthly", "Mensuel"),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof typesOfMeetingFrequencyEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Types of specialists involved in the MDT discussion  -- Using the translatin internally here rather than on client side tsx route.
//
// Primary Care Physicians [checkbox]
// Dermatologists [checkbox]
// ENTs [checkbox]
// Surgical oncologists [checkbox]
// Radiation oncologists [checkbox]
// Pathologists [checkbox]
// Medical oncologists [checkbox]
// Others (please specify) [open box]

export const typesOfSpecialistsInvolvedInTheMDTEnum = [
  "pcps",
  "dermatologists",
  "ents",
  "surgical_oncologists",
  "rad_oncologists",
  "pathologists",
  "medical_oncologists",
  "others",
] as const;
export const mapToTypesOfSpecialistsInvolvedInTheMDTEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof typesOfSpecialistsInvolvedInTheMDTEnum)[number], string> = {
    pcps: l("Primary Care Physicians", "Médecins généralistes"),
    dermatologists: l("Dermatologists", "Dermatologues"),
    ents: l("ENT Surgeons", "Chirurgiens ORL"),
    surgical_oncologists: l("Surgical oncologists", "Oncologues chirurgicaux"),
    rad_oncologists: l("Radiation oncologists", "Radio-oncologues"),
    pathologists: l("Pathologists", "Pathologistes"),
    medical_oncologists: l("Medical oncologists", "Oncologues médicaux"),
    others: l("Others", "Autres"),
  };
  return map[key as (typeof typesOfSpecialistsInvolvedInTheMDTEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Education Learning Programs
//
export const educationLearningProgramsEnum = [
  "conferences",
  "symposiums",
  "webinars",
  "evening_programs",
  "workshops",
  "other",
] as const;
export const mapToEducationLearningProgramsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof educationLearningProgramsEnum)[number], string> = {
    conferences: l("Conferences", "Conférences"),
    symposiums: l("Symposiums", "Symposiums"),
    webinars: l("Webinars", "Webinaires"),
    evening_programs: l("Evening learning programs", "Programmes d'apprentissage en soirée"),
    workshops: l("In-person workshops", "Ateliers en personne"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof educationLearningProgramsEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - CME Preference
//
export const cmePreferenceEnum = ["cme_accredited", "non_cme_accredited"] as const;
export const mapToCmePreferenceEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof cmePreferenceEnum)[number], string> = {
    cme_accredited: l("CME Accredited", "Activité de FMC agréée"),
    non_cme_accredited: l("Non-CME Accredited", "Activité de FMC non agréée"),
  };
  return map[key as (typeof cmePreferenceEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Guidelines Which Parts
//
export const guidelinesWhichPartsEnum = ["screening", "staging", "followup", "none"] as const;
export const mapToGuidelinesWhichPartsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof guidelinesWhichPartsEnum)[number], string> = {
    screening: l("Screening and diagnosis", "Dépistage et diagnostic"),
    staging: l("Staging (including high-risk)", "Stadification (y compris haut risque)"),
    followup: l("Follow-up (post-treatment)", "Suivi (post-traitement)"),
    none: l("None of the above", "Aucune des réponses ci-dessus"),
  };
  return map[key as (typeof guidelinesWhichPartsEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Yes/No (lowercase)
//
export const yesNoLowercaseEnum = ["yes", "no"] as const;
export const mapToYesNoLowercaseEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof yesNoLowercaseEnum)[number], string> = {
    yes: l("Yes", "Oui"),
    no: l("No", "Non"),
  };
  return map[key as (typeof yesNoLowercaseEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Ontario Guidelines Specialties Awareness
//
export const ontarioGuidelinesSpecialtiesEnum = ["pcps", "community_hcps", "academic_hcps", "other"] as const;
export const mapToOntarioGuidelinesSpecialtiesEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof ontarioGuidelinesSpecialtiesEnum)[number], string> = {
    pcps: l("Primary Care Physicians", "Médecins de soins primaires"),
    community_hcps: l("Community HCPs", "Professionnels de la santé communautaires"),
    academic_hcps: l("Academic HCPs", "Professionnels de la santé académiques"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof ontarioGuidelinesSpecialtiesEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Ontario Pathways Details to Include
//
export const ontarioPathwaysDetailsEnum = [
  "specialist_names_contact",
  "specialty_contact",
  "referral_fax",
  "email",
  "nurse_navigator",
  "other",
] as const;
export const mapToOntarioPathwaysDetailsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof ontarioPathwaysDetailsEnum)[number], string> = {
    specialist_names_contact: l(
      "Specialist names with contact numbers",
      "Noms des spécialistes avec numéros de contact",
    ),
    specialty_contact: l(
      "Only specialty listed with contact numbers",
      "Seule la spécialité répertoriée avec les numéros de contact",
    ),
    referral_fax: l("Referral fax numbers", "Numéros de télécopieur de référence"),
    email: l("Email addresses", "Adresses e-mail"),
    nurse_navigator: l("Nurse navigator contacts", "Contacts de navigateur infirmier"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof ontarioPathwaysDetailsEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Navigator Role Vision
//
export const navigatorRoleVisionEnum = ["local", "regional", "provincial"] as const;
export const mapToNavigatorRoleVisionEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof navigatorRoleVisionEnum)[number], string> = {
    local: l("Local", "Local"),
    regional: l("Regional", "Régional"),
    provincial: l("Provincial", "Provincial"),
  };
  return map[key as (typeof navigatorRoleVisionEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic/Alberta Tools Referral Key Information
//
export const toolsReferralKeyInformationEnum = [
  "referral_criteria",
  "nurse_navigator_contacts",
  "imaging_diagnostics",
  "treatment_options",
  "referral_directory",
  "rt_referral_criteria",
  "post_treatment_surveillance",
  "other",
] as const;
export const mapToToolsReferralKeyInformationEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof toolsReferralKeyInformationEnum)[number], string> = {
    referral_criteria: l(
      "Referral criteria (e.g., who to refer to and when)",
      "Critères d'aiguillage du patient (p. ex., référer à qui et quand)",
    ),
    nurse_navigator_contacts: l("Contact details for nurse navigators", "Coordonnées des infirmières pivots"),
    imaging_diagnostics: l("Required imaging and diagnostics", "Imagerie et diagnostics requis"),
    treatment_options: l("Treatment options and guidance", "Options de traitement et conseils"),
    referral_directory: l(
      "Updated referral directory (physician names, fax numbers, wait times)",
      "Répertoire à jour des médecins vers qui aiguiller le patient (nom des médecins, numéros de télécopieur, temps d'attente)",
    ),
    rt_referral_criteria: l("RT referral criteria", "Critères d'aiguillage du patient vers la RT"),
    post_treatment_surveillance: l("Post-treatment surveillance", "Surveillance post-traitement"),
    other: l("Other educational resources", "Autres ressources éducatives"),
  };
  return map[key as (typeof toolsReferralKeyInformationEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic Tools Housing Location
//
export const atlanticToolsHousingLocationEnum = ["ahs_website", "pcn_portals", "other"] as const;
export const mapToAtlanticToolsHousingLocationEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof atlanticToolsHousingLocationEnum)[number], string> = {
    ahs_website: l("AHS website", "Site Web AHS"),
    pcn_portals: l("PCN portals", "Portails PCN"),
    other: l("Other platforms", "Autres plateformes"),
  };
  return map[key as (typeof atlanticToolsHousingLocationEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic/Alberta Education Content
//
export const educationContentEnum = [
  "guidelines",
  "diagnosis_criteria",
  "biopsy_technique",
  "pathology_reading",
  "referral_timing_pathways",
  "management_high_risk",
  "monitoring_followup",
] as const;
export const mapToEducationContentEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof educationContentEnum)[number], string> = {
    guidelines: l("Guidelines", "Lignes directrices"),
    diagnosis_criteria: l("Diagnosis/criteria", "Diagnostic/critères"),
    biopsy_technique: l("Biopsy technique", "Technique de biopsie"),
    pathology_reading: l("Pathology reading", "Lecture de pathologie"),
    referral_timing_pathways: l(
      "Referral timing and treatment pathways",
      "Calendrier de référence et parcours de traitement",
    ),
    management_high_risk: l("Management of high-risk CSCC", "Prise en charge des CEC à risque élevé"),
    monitoring_followup: l("Monitoring and follow-up", "Surveillance et suivi"),
  };
  return map[key as (typeof educationContentEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic Education Remote Target HCPs
//
export const atlanticEducationRemoteTargetHcpsEnum = [
  "general_practitioners",
  "community_dermatologists",
  "plastic_surgeons",
  "surgical_oncologists_community",
  "medical_oncologists_community",
  "other",
] as const;
export const mapToAtlanticEducationRemoteTargetHcpsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof atlanticEducationRemoteTargetHcpsEnum)[number], string> = {
    general_practitioners: l("General Practitioners", "Médecins généralistes"),
    community_dermatologists: l("Community Dermatologists", "Dermatologues communautaires"),
    plastic_surgeons: l("Plastic Surgeons", "Chirurgiens plasticiens"),
    surgical_oncologists_community: l(
      "Surgical Oncologists (in community hospitals)",
      "Oncologues chirurgicaux (dans les hôpitaux communautaires)",
    ),
    medical_oncologists_community: l(
      "Medical Oncologists (in community hospitals)",
      "Oncologues médicaux (dans les hôpitaux communautaires)",
    ),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof atlanticEducationRemoteTargetHcpsEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic Education Remote Who Delivers
//
export const atlanticEducationRemoteWhoDeliversEnum = [
  "primary_care_physicians",
  "dermatologists",
  "mohs_surgeons",
  "ent_surgeons",
  "plastic_surgeons",
  "surgical_oncologists",
  "radiation_oncologists",
  "medical_oncologists",
  "other",
] as const;
export const mapToAtlanticEducationRemoteWhoDeliversEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof atlanticEducationRemoteWhoDeliversEnum)[number], string> = {
    primary_care_physicians: l("Primary Care Physicians", "Médecins de soins primaires"),
    dermatologists: l("Dermatologists", "Dermatologues"),
    mohs_surgeons: l("Mohs Surgeons", "Chirurgiens Mohs"),
    ent_surgeons: l("Ear-Nose-Throat Surgeons", "Chirurgiens ORL"),
    plastic_surgeons: l("Plastic Surgeons", "Chirurgiens plasticiens"),
    surgical_oncologists: l("Surgical Oncologists", "Oncologues chirurgicaux"),
    radiation_oncologists: l("Radiation Oncologists", "Radio-oncologues"),
    medical_oncologists: l("Medical Oncologists", "Oncologues médicaux"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof atlanticEducationRemoteWhoDeliversEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Alberta Guidelines Awareness Who
//
export const albertaGuidelinesAwarenessWhoEnum = [
  "pcps",
  "dermatologists",
  "mohs_surgeons",
  "ent_surgeons",
  "plastic_surgeons",
  "surgical_oncologists",
  "radiation_oncologists",
  "medical_oncologists",
] as const;
export const mapToAlbertaGuidelinesAwarenessWhoEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof albertaGuidelinesAwarenessWhoEnum)[number], string> = {
    pcps: l("PCPs", "Médecins de soins primaires"),
    dermatologists: l("Dermatologists", "Dermatologues"),
    mohs_surgeons: l("Mohs Surgeons", "Chirurgiens Mohs"),
    ent_surgeons: l("Ear-Nose-Throat Surgeons", "Chirurgiens ORL"),
    plastic_surgeons: l("Plastic Surgeons", "Chirurgiens plasticiens"),
    surgical_oncologists: l("Surgical Oncologists", "Oncologues chirurgicaux"),
    radiation_oncologists: l("Radiation Oncologists", "Radio-oncologues"),
    medical_oncologists: l("Medical Oncologists", "Oncologues médicaux"),
  };
  return map[key as (typeof albertaGuidelinesAwarenessWhoEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Alberta Referral Tools Key Stakeholders
//
export const albertaReferralToolsKeyStakeholdersEnum = [
  "pcps",
  "dermatologists",
  "mohs",
  "surgeons",
  "radiation_medical_oncologists",
  "other",
] as const;
export const mapToAlbertaReferralToolsKeyStakeholdersEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof albertaReferralToolsKeyStakeholdersEnum)[number], string> = {
    pcps: l("PCPs", "Médecins de soins primaires"),
    dermatologists: l("Dermatologists", "Dermatologues"),
    mohs: l("Mohs", "Mohs"),
    surgeons: l("Surgeons", "Chirurgiens"),
    radiation_medical_oncologists: l("Radiation/Medical Oncologists", "Radio-oncologues/Oncologues médicaux"),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof albertaReferralToolsKeyStakeholdersEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Alberta HCP Education Preferred Format
//
export const albertaHcpEducationPreferredFormatEnum = [
  "case_based",
  "webinar_panel",
  "community_education",
  "enduring_content",
  "connect_care_modules",
  "family_practice_residents",
  "accredited_education",
] as const;
export const mapToAlbertaHcpEducationPreferredFormatEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof albertaHcpEducationPreferredFormatEnum)[number], string> = {
    case_based: l("Case based learning", "Apprentissage basé sur des cas"),
    webinar_panel: l("Webinar – panel discussion", "Webinaire – table ronde"),
    community_education: l(
      "Community-based education delivered by academic speakers",
      "Éducation communautaire dispensée par des conférenciers académiques",
    ),
    enduring_content: l("Enduring content modules", "Modules de contenu durable"),
    connect_care_modules: l("Connect Care based modules", "Modules basés sur Connect Care"),
    family_practice_residents: l("Family practice residents training", "Formation des résidents en médecine familiale"),
    accredited_education: l("Accredited education", "Études agréées"),
  };
  return map[key as (typeof albertaHcpEducationPreferredFormatEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - National Consensus Care Pathway Focus
//
export const nationalConsensusPathwayFocusEnum = [
  "screening_diagnosis",
  "staging_high_risk_assessment",
  "monitoring_followup_post_treatment",
  "other",
] as const;
export const mapToNationalConsensusPathwayFocusEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof nationalConsensusPathwayFocusEnum)[number], string> = {
    screening_diagnosis: l("Screening and diagnosis", "Dépistage et diagnostic"),
    staging_high_risk_assessment: l(
      "Staging (including high-risk assessment)",
      "Stadification (y compris l'évaluation des risques élevés)",
    ),
    monitoring_followup_post_treatment: l(
      "Monitoring and Follow-up (post-treatment)",
      "Surveillance et suivi (post-traitement)",
    ),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof nationalConsensusPathwayFocusEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Alberta Next Steps Interested In
//
export const albertaNextStepsInterestedInEnum = [
  "national_consensus",
  "updating_guidelines",
  "implementing_pathways",
  "formulating_triaging",
  "updating_pathology",
  "supporting_mdt",
  "hcp_education",
] as const;
export const mapToAlbertaNextStepsInterestedInEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof albertaNextStepsInterestedInEnum)[number], string> = {
    national_consensus: l(
      "National Consensus on NMSC care practices",
      "Consensus national sur les pratiques de soins du NMSC",
    ),
    updating_guidelines: l("Updating provincial guidelines", "Mise à jour des lignes directrices provinciales"),
    implementing_pathways: l("Implementing provincial pathways", "Mise en œuvre des voies provinciales"),
    formulating_triaging: l("Formulating triaging pathways", "Formulation des voies de triage"),
    updating_pathology: l("Updating pathology reporting", "Mise à jour des rapports de pathologie"),
    supporting_mdt: l("Supporting MDT networks", "Soutien des réseaux MDT"),
    hcp_education: l("HCP education", "Éducation des professionnels de la santé"),
  };
  return map[key as (typeof albertaNextStepsInterestedInEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - CME Preference with No Preference Option
//
export const cmePreferenceV2Enum = ["cme_accredited", "non_cme_accredited", "no_preference"] as const;
export const mapToCmePreferenceV2EnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof cmePreferenceV2Enum)[number], string> = {
    cme_accredited: l("CME Accredited", "Activité de FMC agréée"),
    non_cme_accredited: l("Non-CME Accredited", "Activité de FMC non agréée"),
    no_preference: l("No preference", "Aucune préférence"),
  };
  return map[key as (typeof cmePreferenceV2Enum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Alberta Guidelines Awareness Who (with Pathologists)
//
export const albertaGuidelinesAwarenessWhoV2Enum = [
  "pcps",
  "dermatologists",
  "pathologists",
  "mohs_surgeons",
  "ent_surgeons",
  "plastic_surgeons",
  "surgical_oncologists",
  "radiation_oncologists",
  "medical_oncologists",
] as const;
export const mapToAlbertaGuidelinesAwarenessWhoV2EnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof albertaGuidelinesAwarenessWhoV2Enum)[number], string> = {
    pcps: l("Primary Care Physicians", "Médecins de soins primaires"),
    dermatologists: l("Dermatologists", "Dermatologues"),
    pathologists: l("Pathologists", "Pathologistes"),
    mohs_surgeons: l("Mohs Surgeons", "Chirurgiens Mohs"),
    ent_surgeons: l("Ear-Nose-Throat Surgeons", "Chirurgiens ORL"),
    plastic_surgeons: l("Plastic Surgeons", "Chirurgiens plasticiens"),
    surgical_oncologists: l("Surgical Oncologists", "Oncologues chirurgicaux"),
    radiation_oncologists: l("Radiation Oncologists", "Radio-oncologues"),
    medical_oncologists: l("Medical Oncologists", "Oncologues médicaux"),
  };
  return map[key as (typeof albertaGuidelinesAwarenessWhoV2Enum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Alberta Referral Tools Key Stakeholders
//
export const albertaReferralToolsKeyStakeholdersV2Enum = [
  "pcps",
  "dermatologists",
  "mohs_surgeons",
  "ent_surgeons",
  "surgical_oncologists",
  "plastic_surgeons",
  "radiation_medical_oncologists",
  "other",
] as const;
export const mapToAlbertaReferralToolsKeyStakeholdersV2EnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof albertaReferralToolsKeyStakeholdersV2Enum)[number], string> = {
    pcps: l("Primary Care Physicians", "Médecins de soins primaires"),
    dermatologists: l("Dermatologists", "Dermatologues"),
    mohs_surgeons: l("Mohs Surgeons", "Chirurgiens Mohs"),
    ent_surgeons: l("Ear-Nose-Throat Surgeons", "Chirurgiens ORL"),
    surgical_oncologists: l("Surgical Oncologists", "Oncologues chirurgicaux"),
    plastic_surgeons: l("Plastic Surgeons", "Chirurgiens plasticiens"),
    radiation_medical_oncologists: l("Radiation/Medical Oncologists", "Radio-oncologues/Oncologues médicaux"),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof albertaReferralToolsKeyStakeholdersV2Enum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Alberta HCP Education Preferred Format
//
export const albertaHcpEducationPreferredFormatV2Enum = [
  "case_based",
  "webinar_panel",
  "community_education",
  "enduring_content",
  "connect_care_modules",
  "family_practice_residents",
  "accredited_education",
  "institutional_programs",
  "other",
] as const;
export const mapToAlbertaHcpEducationPreferredFormatV2EnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof albertaHcpEducationPreferredFormatV2Enum)[number], string> = {
    case_based: l("Case-based learning", "Apprentissage fondé sur des études de cas"),
    webinar_panel: l("Webinar – panel discussion", "Webinaire – table ronde"),
    community_education: l(
      "Community-based education delivered by academic speakers",
      "Éducation communautaire offerte par des conférenciers universitaires",
    ),
    enduring_content: l("Enduring content modules", "Modules de contenu durable"),
    connect_care_modules: l("Connect Care-based modules", "Modules Connect Care"),
    family_practice_residents: l("Family practice residents training", "Formation des résidents en médecine familiale"),
    accredited_education: l("Accredited education", "Études agréées"),
    institutional_programs: l("Institutional programs", "Programmes institutionnels"),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof albertaHcpEducationPreferredFormatV2Enum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Pathology Commentary Recommendations
//
export const pathologyCommentaryRecommendEnum = ["specialty_referral", "mdt_review"] as const;
export const mapToPathologyCommentaryRecommendEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof pathologyCommentaryRecommendEnum)[number], string> = {
    specialty_referral: l(
      "Specialty referral based on criteria",
      "Orientation vers une spécialité basée sur des critères",
    ),
    mdt_review: l("Need for multidisciplinary review", "Besoin d'examen multidisciplinaire"),
  };
  return map[key as (typeof pathologyCommentaryRecommendEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic Support Tools Key Stakeholders
//
export const atlanticSupportToolsKeyStakeholdersEnum = [
  "pcps",
  "dermatologists",
  "mohs_surgeons",
  "surgeons",
  "radiation_medical_oncologists",
  "other",
] as const;
export const mapToAtlanticSupportToolsKeyStakeholdersEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof atlanticSupportToolsKeyStakeholdersEnum)[number], string> = {
    pcps: l("Primary Care Physicians", "Médecins de soins primaires"),
    dermatologists: l("Dermatologists", "Dermatologues"),
    mohs_surgeons: l("Mohs Surgeons", "Chirurgiens Mohs"),
    surgeons: l("Surgeons", "Chirurgiens"),
    radiation_medical_oncologists: l("Radiation/Medical Oncologists", "Radio-oncologues/Oncologues médicaux"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof atlanticSupportToolsKeyStakeholdersEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic Guidelines Which Parts
//
export const atlanticGuidelinesWhichPartsEnum = ["screening", "staging", "followup", "other"] as const;
export const mapToAtlanticGuidelinesWhichPartsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof atlanticGuidelinesWhichPartsEnum)[number], string> = {
    screening: l("Screening and diagnosis", "Dépistage et diagnostic"),
    staging: l("Staging (including high-risk assessment)", "Stadification (y compris l'évaluation du risque élevé)"),
    followup: l("Monitoring and follow-up (post-treatment)", "Surveillance et suivi (après le traitement)"),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof atlanticGuidelinesWhichPartsEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic Education Content
//
export const atlanticEducationContentEnum = [
  "guidelines",
  "diagnosis_criteria",
  "biopsy_technique",
  "pathology_reading",
  "referral_timing_treatment_pathways",
  "management_high_risk",
  "monitoring_followup",
  "overview_nmsc",
  "bcc_vs_cscc",
  "other",
] as const;
export const mapToAtlanticEducationContentEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof atlanticEducationContentEnum)[number], string> = {
    guidelines: l("Guidelines", "Lignes directrices"),
    diagnosis_criteria: l("Diagnosis/criteria", "Diagnostic/critères"),
    biopsy_technique: l("Biopsy technique", "Technique de biopsie"),
    pathology_reading: l("Pathology reading", "Lecture de pathologie"),
    referral_timing_treatment_pathways: l(
      "Referral timing and treatment pathways",
      "Calendrier des demandes d'aiguillage et parcours de traitement",
    ),
    management_high_risk: l("Management of high-risk CSCC", "Prise en charge des CEC à risque élevé"),
    monitoring_followup: l("Monitoring and follow-up", "Surveillance et suivi"),
    overview_nmsc: l("Overview of NMSC", "Aperçu du CPNM"),
    bcc_vs_cscc: l("BCC vs. CSCC", "CBC vs CEC"),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof atlanticEducationContentEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic Tools Referral Key Information
//
export const atlanticToolsReferralKeyInformationEnum = [
  "referral_criteria",
  "nurse_navigator_contacts",
  "imaging_diagnostics",
  "treatment_options",
  "referral_directory",
  "rt_referral_criteria",
  "post_treatment_surveillance",
  "other",
] as const;
export const mapToAtlanticToolsReferralKeyInformationEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof atlanticToolsReferralKeyInformationEnum)[number], string> = {
    referral_criteria: l(
      "Referral criteria (e.g., who to refer to and when)",
      "Critères d'aiguillage du patient (p. ex., référer à qui et quand)",
    ),
    nurse_navigator_contacts: l("Contact details for nurse navigators", "Coordonnées des infirmières pivots"),
    imaging_diagnostics: l("Required imaging and diagnostics", "Imagerie et diagnostics requis"),
    treatment_options: l("Treatment options and guidance", "Options de traitement et conseils"),
    referral_directory: l(
      "Updated referral directory (physician names, fax numbers, wait times)",
      "Répertoire à jour des médecins vers qui aiguiller le patient (nom des médecins, numéros de télécopieur, temps d'attente)",
    ),
    rt_referral_criteria: l("RT referral criteria", "Critères d'aiguillage du patient vers la RT"),
    post_treatment_surveillance: l("Post-treatment surveillance", "Surveillance post-traitement"),
    other: l("Other educational resources", "Autres ressources éducatives"),
  };
  return map[key as (typeof atlanticToolsReferralKeyInformationEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic Education Preferred Format
//
export const atlanticEducationPreferredFormatEnum = [
  "conferences_symposia",
  "case_based",
  "webinar_panel",
  "community_education",
  "enduring_content",
  "family_practice_residents",
  "accredited_education",
  "institutional_programs",
  "other",
] as const;
export const mapToAtlanticEducationPreferredFormatEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof atlanticEducationPreferredFormatEnum)[number], string> = {
    conferences_symposia: l("Conferences/symposia", "Conférences/symposiums"),
    case_based: l("Case-based learning", "Apprentissage fondé sur des études de cas"),
    webinar_panel: l("Webinar – panel discussion", "Webinaire – table ronde"),
    community_education: l(
      "Community-based education delivered by academic speakers",
      "Éducation communautaire offerte par des conférenciers universitaires",
    ),
    enduring_content: l("Enduring content modules", "Modules de contenu durable"),
    family_practice_residents: l("Family practice residents training", "Formation des résidents en médecine familiale"),
    accredited_education: l("Accredited education", "Études agréées"),
    institutional_programs: l("Institutional programs", "Programmes institutionnels"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof atlanticEducationPreferredFormatEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic Education Preferred Format Community (variant without conferences/symposia, with connect care)
//
export const atlanticEducationPreferredFormatCommunityEnum = [
  "case_based",
  "webinar_panel",
  "community_education",
  "enduring_content",
  "connect_care_modules",
  "family_practice_residents",
  "accredited_education",
  "institutional_programs",
  "other",
] as const;
export const mapToAtlanticEducationPreferredFormatCommunityEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof atlanticEducationPreferredFormatCommunityEnum)[number], string> = {
    case_based: l("Case-based learning", "Apprentissage fondé sur des études de cas"),
    webinar_panel: l("Webinar – panel discussion", "Webinaire – table ronde"),
    community_education: l(
      "Community-based education delivered by academic speakers",
      "Éducation communautaire offerte par des conférenciers universitaires",
    ),
    enduring_content: l("Enduring content modules", "Modules de contenu durable"),
    connect_care_modules: l("Connect Care-based modules", "Modules Connect Care"),
    family_practice_residents: l("Family practice residents training", "Formation des résidents en médecine familiale"),
    accredited_education: l("Accredited education", "Éducation agréée"),
    institutional_programs: l("Institutional programs", "Programmes institutionnels"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof atlanticEducationPreferredFormatCommunityEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Education Content (with referral timing and systemic IO)
//
export const educationContentV2Enum = [
  "guidelines",
  "diagnosis_criteria",
  "biopsy_technique",
  "pathology_reading",
  "referral_timing_systemic_io",
  "management_high_risk",
  "other",
] as const;
export const mapToEducationContentV2EnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof educationContentV2Enum)[number], string> = {
    guidelines: l("Guidelines", "Lignes directrices"),
    diagnosis_criteria: l("Diagnosis/criteria", "Diagnostic/critères"),
    biopsy_technique: l("Biopsy technique", "Technique de biopsie"),
    pathology_reading: l("Pathology reading", "Lecture de pathologie"),
    referral_timing_systemic_io: l(
      "Referral timing and systemic IO treatment options",
      "Calendrier des demandes d'aiguillage et options de traitement systémique par immunothérapie",
    ),
    management_high_risk: l("Management of high-risk CSCC", "Prise en charge des CEC à risque élevé"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof educationContentV2Enum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic Next Steps Interested In
//
export const atlanticNextStepsInterestedInEnum = [
  "consensus",
  "support_tool",
  "triage_pathway",
  "education",
  "pathology_reporting",
] as const;
export const mapToAtlanticNextStepsInterestedInEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof atlanticNextStepsInterestedInEnum)[number], string> = {
    consensus: l(
      "Consensus on NMSC care practices",
      "Consensus sur les pratiques de soins destinés au traitement du CPNM",
    ),
    support_tool: l(
      "A clinical decision-support and referral tool",
      "Un outil d'aiguillage et d'aide à la décision clinique",
    ),
    triage_pathway: l("A standardized triage pathway", "Un protocole de triage normalisé"),
    education: l(
      "NMSC education for HCPs and patients",
      "Éducation des professionnels de la santé et des patients sur les CPNM",
    ),
    pathology_reporting: l("Updating pathology reporting", "Mise à jour de l'établissement des rapports de pathologie"),
  };
  return map[key as (typeof atlanticNextStepsInterestedInEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - Atlantic Patient Education Format (not currently used)
//
export const atlanticPatientEducationFormatEnum = [
  "printed_pamphlets",
  "websites",
  "qr_codes",
  "videos",
  "patient_groups",
  "other",
] as const;
export const mapToAtlanticPatientEducationFormatEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof atlanticPatientEducationFormatEnum)[number], string> = {
    printed_pamphlets: l("Printed pamphlets", "Brochures imprimées"),
    websites: l("Websites", "Sites web"),
    qr_codes: l("QR codes", "Codes QR"),
    videos: l("Videos in waiting rooms", "Vidéos dans les salles d'attente"),
    patient_groups: l("Collaboration with patient groups", "Collaboration avec les groupes de patients"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof atlanticPatientEducationFormatEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Quebec Consensus Care Pathway Parts
//
export const quebecConsensusPathwayPartsEnum = [
  "screening_diagnosis",
  "staging",
  "monitoring_followup",
  "other",
] as const;
export const mapToQuebecConsensusPathwayPartsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof quebecConsensusPathwayPartsEnum)[number], string> = {
    screening_diagnosis: l("Screening and diagnosis", "Dépistage et diagnostic"),
    staging: l("Staging (including high-risk)", "Stadification (y compris risques élevés)"),
    monitoring_followup: l("Monitoring and follow-up (post-treatment)", "Surveillance et suivi (après le traitement)"),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof quebecConsensusPathwayPartsEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Quebec HCP Education Content
//
export const quebecHcpEducationContentEnum = [
  "guidelines",
  "diagnosis_criteria",
  "biopsy_technique",
  "pathology_reading",
  "referral_timing_io",
  "management_high_risk",
] as const;
export const mapToQuebecHcpEducationContentEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof quebecHcpEducationContentEnum)[number], string> = {
    guidelines: l("Guidelines", "Lignes directrices"),
    diagnosis_criteria: l("Diagnosis/criteria", "Diagnostic/critères"),
    biopsy_technique: l("Biopsy technique", "Technique de biopsie"),
    pathology_reading: l("Pathology reading", "Lecture de pathologie"),
    referral_timing_io: l(
      "Referral timing and systemic IO treatment options",
      "Calendrier des demandes d'aiguillage et options de traitement systémique par immunothérapie",
    ),
    management_high_risk: l("Identification, monitoring and management of high-risk CSCC", "Identification, surveillance et prise en charge des CEC à risque élevé"),
  };
  return map[key as (typeof quebecHcpEducationContentEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Quebec HCP Education Format
//
export const quebecHcpEducationFormatEnum = [
  "conferences_symposia",
  "case_based",
  "webinar_panel",
  "community_education",
  "enduring_content",
  "family_practice_residents",
  "accredited_education",
  "institutional_programs",
  "other",
] as const;
export const mapToQuebecHcpEducationFormatEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof quebecHcpEducationFormatEnum)[number], string> = {
    conferences_symposia: l("Conferences/symposia", "Conférences/symposiums"),
    case_based: l("Case-based learning", "Apprentissage fondé sur des études de cas"),
    webinar_panel: l("Webinar – panel discussion", "Webinaire – table ronde"),
    community_education: l(
      "Community-based education delivered by academic speakers",
      "Éducation communautaire offerte par des conférenciers universitaires",
    ),
    enduring_content: l("Enduring content modules", "Modules de contenu durable"),
    family_practice_residents: l("Family practice residents training", "Formation des résidents en médecine familiale"),
    accredited_education: l("Accredited education", "Études agréées"),
    institutional_programs: l("Institutional programs", "Programmes institutionnels"),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof quebecHcpEducationFormatEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Quebec Patient Education Topics
//
export const quebecPatientEducationTopicsEnum = [
  "nmsc_identification",
  "diagnosis",
  "treatment_options",
  "treatment_side_effects",
  "monitoring",
  "patient_journey",
  "other",
] as const;
export const mapToQuebecPatientEducationTopicsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof quebecPatientEducationTopicsEnum)[number], string> = {
    nmsc_identification: l("NMSC identification", "Identification du CPNM"),
    diagnosis: l("Diagnosis", "Diagnostic"),
    treatment_options: l("Treatment options", "Options de traitement"),
    treatment_side_effects: l("Treatment side effects", "Effets secondaires du traitement"),
    monitoring: l("Monitoring", "Surveillance"),
    patient_journey: l("Patient journey", "Parcours du patient"),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof quebecPatientEducationTopicsEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Quebec Remote Education Target HCPs
//
export const quebecRemoteEducationTargetHcpsEnum = [
  "general_practitioners",
  "community_dermatologists",
  "plastic_surgeons",
  "surgical_oncologists_community",
  "medical_oncologists_community",
  "other",
] as const;
export const mapToQuebecRemoteEducationTargetHcpsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof quebecRemoteEducationTargetHcpsEnum)[number], string> = {
    general_practitioners: l("General Practitioners", "Médecins généralistes"),
    community_dermatologists: l("Community Dermatologists", "Dermatologues communautaires"),
    plastic_surgeons: l("Plastic Surgeons", "Chirurgiens plasticiens"),
    surgical_oncologists_community: l(
      "Surgical Oncologists (in community hospitals)",
      "Oncologues chirurgicaux (dans les hôpitaux communautaires)",
    ),
    medical_oncologists_community: l(
      "Medical Oncologists (in community hospitals)",
      "Oncologues médicaux (dans les hôpitaux communautaires)",
    ),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof quebecRemoteEducationTargetHcpsEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Quebec Remote Education Who Delivers
//
export const quebecRemoteEducationWhoDeliversEnum = [
  "primary_care_physicians",
  "dermatologists",
  "mohs_surgeons",
  "ent_surgeons",
  "plastic_surgeons",
  "surgical_oncologists",
  "radiation_oncologists",
  "medical_oncologists",
  "other",
] as const;
export const mapToQuebecRemoteEducationWhoDeliversEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof quebecRemoteEducationWhoDeliversEnum)[number], string> = {
    primary_care_physicians: l("Primary Care Physicians", "Médecins de soins primaires"),
    dermatologists: l("Dermatologists", "Dermatologues"),
    mohs_surgeons: l("Mohs Surgeons", "Chirurgiens Mohs"),
    ent_surgeons: l("Ear-Nose-Throat Surgeons", "Chirurgiens ORL"),
    plastic_surgeons: l("Plastic Surgeons", "Chirurgiens plasticiens"),
    surgical_oncologists: l("Surgical Oncologists", "Oncologues chirurgicaux"),
    radiation_oncologists: l("Radiation Oncologists", "Radio-oncologues"),
    medical_oncologists: l("Medical Oncologists", "Oncologues médicaux"),
    other: l("Other (please specify)", "Autre (veuillez préciser)"),
  };
  return map[key as (typeof quebecRemoteEducationWhoDeliversEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Quebec Next Steps Priorities
//
export const quebecNextStepsPrioritiesEnum = [
  "consensus_care_practices",
  "connecting_physicians_specialists",
  "hcp_patient_education",
] as const;
export const mapToQuebecNextStepsPrioritiesEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof quebecNextStepsPrioritiesEnum)[number], string> = {
    consensus_care_practices: l(
      "Consensus on NMSC care practices (especially patient follow-ups)",
      "Consensus sur les pratiques de soins pour le CPNM (en particulier le suivi des patients)",
    ),
    connecting_physicians_specialists: l(
      "Connecting community physicians and specialists",
      "Relier les médecins et les spécialistes communautaires",
    ),
    hcp_patient_education: l(
      "HCP and Patient Education on NMSCs",
      "Éducation des professionnels de la santé et des patients sur les CPNM",
    ),
  };
  return map[key as (typeof quebecNextStepsPrioritiesEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Ontario Education Learning Programs (with institutional)
//
export const ontarioEducationLearningProgramsEnum = [
  "conferences",
  "symposiums",
  "webinars",
  "institutional_programs",
  "evening_programs",
  "workshops",
  "other",
] as const;
export const mapToOntarioEducationLearningProgramsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof ontarioEducationLearningProgramsEnum)[number], string> = {
    conferences: l("Conferences", "Conférences"),
    symposiums: l("Symposium", "Symposium"),
    webinars: l("Webinars", "Webinaires"),
    institutional_programs: l("Institutional learning programs", "Programmes d'apprentissage institutionnels"),
    evening_programs: l("Evening learning programs", "Programmes d'apprentissage en soirée"),
    workshops: l("In-person workshops", "Ateliers en personne"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof ontarioEducationLearningProgramsEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums V2 - Ontario Next Steps Priorities
//
export const ontarioNextStepsPrioritiesEnum = [
  "updating_pathology",
  "increasing_awareness_guidelines",
  "curating_specialist_list",
  "collecting_rwe",
  "patient_navigation",
  "educating_hcps",
] as const;
export const mapToOntarioNextStepsPrioritiesEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof ontarioNextStepsPrioritiesEnum)[number], string> = {
    updating_pathology: l("Updating pathology reporting", "Mise à jour des rapports de pathologie"),
    increasing_awareness_guidelines: l(
      "Increasing community awareness of provincial guidelines",
      "Accroître la sensibilisation de la communauté aux lignes directrices provinciales",
    ),
    curating_specialist_list: l(
      "Curating a specialist referral list for community HCPs in the province",
      "Organiser une liste de références de spécialistes pour les professionnels de la santé communautaires de la province",
    ),
    collecting_rwe: l(
      "Collecting real world evidence for the true incidence of NMSCs",
      "Collecter des preuves du monde réel sur la véritable incidence des NMSC",
    ),
    patient_navigation: l("Patient journey navigation", "Navigation dans le parcours du patient"),
    educating_hcps: l(
      "Educating HCPs about management of NMSCs",
      "Éduquer les professionnels de la santé sur la gestion des NMSC",
    ),
  };
  return map[key as (typeof ontarioNextStepsPrioritiesEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - British Columbia National Consensus Pathway
//
export const bcNationalConsensusPathwayEnum = [
  "screening_diagnosis",
  "staging_high_risk_assessment",
  "monitoring_follow_up",
  "other",
] as const;
export const mapToBcNationalConsensusPathwayEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof bcNationalConsensusPathwayEnum)[number], string> = {
    screening_diagnosis: l("Screening and diagnosis", "Dépistage et diagnostic"),
    staging_high_risk_assessment: l("Staging (including high-risk assessment)", "Stadification (y compris l'évaluation des risques élevés)"),
    monitoring_follow_up: l("Monitoring and follow-up (post-treatment)", "Surveillance et suivi (post-traitement)"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof bcNationalConsensusPathwayEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - British Columbia National Consensus Specialties (9 specialties for deck requirements)
//
export const bcNationalConsensusSpecialtiesEnum = [
  "pcps",
  "dermatologists",
  "pathologists",
  "mohs_surgeons",
  "ent_surgeons",
  "plastic_surgeons",
  "surgical_oncologists",
  "radiation_oncologists",
  "medical_oncologists",
] as const;
export const mapToBcNationalConsensusSpecialtiesEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof bcNationalConsensusSpecialtiesEnum)[number], string> = {
    pcps: l("Primary Care Physicians", "Médecins de soins primaires"),
    dermatologists: l("Dermatologists", "Dermatologues"),
    pathologists: l("Pathologists", "Pathologistes"),
    mohs_surgeons: l("Mohs Surgeons", "Chirurgiens Mohs"),
    ent_surgeons: l("Ear-Nose-Throat Surgeons", "Chirurgiens ORL"),
    plastic_surgeons: l("Plastic Surgeons", "Chirurgiens plasticiens"),
    surgical_oncologists: l("Surgical Oncologists", "Oncologues chirurgicaux"),
    radiation_oncologists: l("Radiation Oncologists", "Radio-oncologues"),
    medical_oncologists: l("Medical Oncologists", "Oncologues médicaux"),
  };
  return map[key as (typeof bcNationalConsensusSpecialtiesEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - British Columbia Guidelines Awareness Who (10 specialties including Oncology Pharmacists)
//
export const bcGuidelinesAwarenessWhoEnum = [
  "pcps",
  "dermatologists",
  "pathologists",
  "mohs_surgeons",
  "ent_surgeons",
  "plastic_surgeons",
  "surgical_oncologists",
  "oncology_pharmacists",
  "radiation_oncologists",
  "medical_oncologists",
] as const;
export const mapToBcGuidelinesAwarenessWhoEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof bcGuidelinesAwarenessWhoEnum)[number], string> = {
    pcps: l("Primary Care Physicians", "Médecins de soins primaires"),
    dermatologists: l("Dermatologists", "Dermatologues"),
    pathologists: l("Pathologists", "Pathologistes"),
    mohs_surgeons: l("Mohs Surgeons", "Chirurgiens Mohs"),
    ent_surgeons: l("Ear-Nose-Throat Surgeons", "Chirurgiens ORL"),
    plastic_surgeons: l("Plastic Surgeons", "Chirurgiens plasticiens"),
    surgical_oncologists: l("Surgical Oncologists", "Oncologues chirurgicaux"),
    oncology_pharmacists: l("Oncology Pharmacists", "Pharmaciens en oncologie"),
    radiation_oncologists: l("Radiation Oncologists", "Radio-oncologues"),
    medical_oncologists: l("Medical Oncologists", "Oncologues médicaux"),
  };
  return map[key as (typeof bcGuidelinesAwarenessWhoEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - British Columbia Provincial Navigation Tools Information
//
export const bcProvincialNavigationToolsInfoEnum = [
  "referral_criteria",
  "nurse_navigator_contacts",
  "imaging_diagnostics",
  "treatment_options",
  "referral_directory",
  "rt_referral_criteria",
  "post_treatment_surveillance",
  "other",
] as const;
export const mapToBcProvincialNavigationToolsInfoEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof bcProvincialNavigationToolsInfoEnum)[number], string> = {
    referral_criteria: l(
      "Referral criteria (e.g., who to refer to and when)",
      "Critères d'aiguillage du patient (p. ex., référer à qui et quand)",
    ),
    nurse_navigator_contacts: l(
      "Contact details for nurse navigators (if available)",
      "Coordonnées des navigateurs infirmiers (si disponibles)",
    ),
    imaging_diagnostics: l("Required imaging and diagnostics", "Imagerie et diagnostics requis"),
    treatment_options: l("Treatment options and guidance", "Options de traitement et conseils"),
    referral_directory: l(
      "Updated referral directory (organized by geography and sub-specialty, with fax numbers)",
      "Répertoire de référence mis à jour (organisé par géographie et sous-spécialité, avec numéros de télécopieur)",
    ),
    rt_referral_criteria: l("RT referral criteria", "Critères d'aiguillage du patient vers la RT"),
    post_treatment_surveillance: l("Post-treatment surveillance", "Surveillance post-traitement"),
    other: l("Other educational resources", "Autres ressources éducatives"),
  };
  return map[key as (typeof bcProvincialNavigationToolsInfoEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - British Columbia Provincial Navigation Stakeholders
//
export const bcProvincialNavigationStakeholdersEnum = [
  "primary_care_physicians",
  "dermatologists",
  "mohs_surgeons",
  "ent_surgeons",
  "surgical_oncologists",
  "plastic_surgeons",
  "radiation_medical_oncologists",
  "other",
] as const;
export const mapToBcProvincialNavigationStakeholdersEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof bcProvincialNavigationStakeholdersEnum)[number], string> = {
    primary_care_physicians: l("Primary Care Physicians", "Médecins de soins primaires"),
    dermatologists: l("Dermatologists", "Dermatologues"),
    mohs_surgeons: l("Mohs Surgeons", "Chirurgiens Mohs"),
    ent_surgeons: l("Ear-Nose-Throat Surgeons", "Chirurgiens ORL"),
    surgical_oncologists: l("Surgical Oncologists", "Oncologues chirurgicaux"),
    plastic_surgeons: l("Plastic Surgeons", "Chirurgiens plasticiens"),
    radiation_medical_oncologists: l("Radiation/Medical Oncologists", "Radio-oncologues/Oncologues médicaux"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof bcProvincialNavigationStakeholdersEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - British Columbia Triaging Tools
//
export const bcTriagingToolsEnum = [
  "nurse_navigators",
  "standardized_template",
  "power_plans",
  "quick_reference_digital_tool",
  "centralized_hotline",
  "other",
] as const;
export const mapToBcTriagingToolsEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof bcTriagingToolsEnum)[number], string> = {
    nurse_navigators: l("Nurse navigation", "Navigation infirmière"),
    standardized_template: l("Standardized template", "Modèle standardisé"),
    power_plans: l("Use of power plans", "Utilisation de plans de puissance"),
    quick_reference_digital_tool: l("Quick reference/digital tool", "Outil de référence rapide/numérique"),
    centralized_hotline: l("Centralized hotline", "Ligne directe centralisée"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof bcTriagingToolsEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - British Columbia Education Preferred Format
//
export const bcEducationPreferredFormatEnum = [
  "case_based",
  "webinar_panel",
  "community_education",
  "enduring_content",
  "family_practice_residents",
  "accredited_education",
  "searchable_forum",
  "other",
] as const;
export const mapToBcEducationPreferredFormatEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof bcEducationPreferredFormatEnum)[number], string> = {
    case_based: l("Case-based learning", "Apprentissage fondé sur des études de cas"),
    webinar_panel: l("Webinar – panel discussion", "Webinaire – table ronde"),
    community_education: l(
      "Community-based education delivered by academic speakers",
      "Éducation communautaire dispensée par des conférenciers académiques",
    ),
    enduring_content: l("Enduring content modules", "Modules de contenu durable"),
    family_practice_residents: l("Family practice residents training", "Formation des résidents en médecine familiale"),
    accredited_education: l("Accredited education", "Études agréées"),
    searchable_forum: l(
      "Creation of a searchable forum for Q&A",
      "Création d'un forum de questions-réponses consultable",
    ),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof bcEducationPreferredFormatEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - British Columbia Education Priority Specialties
//
export const bcEducationPrioritySpecialtiesEnum = [
  "primary_care",
  "community_dermatologists",
  "community_ent",
  "general_surgeons",
  "plastic_surgeons",
  "head_neck_oncologists",
  "medical_students_residents",
  "nursing_navigators",
  "other",
] as const;
export const mapToBcEducationPrioritySpecialtiesEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof bcEducationPrioritySpecialtiesEnum)[number], string> = {
    primary_care: l("Primary Care Physicians", "Médecins de soins primaires"),
    community_dermatologists: l("Community Dermatologists", "Dermatologues communautaires"),
    community_ent: l("Community Ear-Nose-Throat Surgeons", "Chirurgiens ORL communautaires"),
    general_surgeons: l("General Surgeons", "Chirurgiens généraux"),
    plastic_surgeons: l("Plastic Surgeons", "Chirurgiens plasticiens"),
    head_neck_oncologists: l(
      "Head and Neck Medical Oncologists and/or Radiation Oncologists",
      "Oncologues médicaux et/ou radio-oncologues de la tête et du cou",
    ),
    medical_students_residents: l("Medical students/residents", "Étudiants en médecine/résidents"),
    nursing_navigators: l("Nursing/Nurse navigators", "Infirmières/Navigateurs infirmiers"),
    other: l("Other", "Autre"),
  };
  return map[key as (typeof bcEducationPrioritySpecialtiesEnum)[number]] ?? l("Unknown", "Inconnu");
};

//
// Phase 2 Enums - British Columbia Next Steps Initiatives
//
export const bcNextStepsInitiativesEnum = [
  "national_consensus",
  "updating_guidelines",
  "implementing_pathways",
  "formulating_triaging",
  "updating_pathology",
  "supporting_mdt",
  "hcp_education",
] as const;
export const mapToBcNextStepsInitiativesEnumLabels = (key: string, l: I18NFunction) => {
  const map: Record<(typeof bcNextStepsInitiativesEnum)[number], string> = {
    national_consensus: l("National Consensus on NMSC care path", "Consensus national sur le parcours de soins NMSC"),
    updating_guidelines: l("Updating provincial guidelines", "Mise à jour des lignes directrices provinciales"),
    implementing_pathways: l("Implementing provincial pathways", "Mise en œuvre des voies provinciales"),
    formulating_triaging: l("Formulating triaging pathways", "Formulation des voies de triage"),
    updating_pathology: l("Updating pathology reporting", "Mise à jour des rapports de pathologie"),
    supporting_mdt: l("Supporting MDT networks", "Soutien des réseaux MDT"),
    hcp_education: l("HCP education", "Éducation des professionnels de la santé"),
  };
  return map[key as (typeof bcNextStepsInitiativesEnum)[number]] ?? l("Unknown", "Inconnu");
};
